
export const hasErrors = (data: any): data is ResponseError[] => {
    return Array.isArray(data) && data.length != 0 && !!data[0].location;
};
